export const formatQueryParams = filter => {
  const queryParams = [];

  if (!filter.length) {
    return "";
  }
  filter.forEach(item => {
    Object.entries(item).forEach(([key, value]) => {
      queryParams.push(`${key}=${value}`);
    });
  });
  const queryString = queryParams.join("&");

  if (!queryString) {
    return ``;
  }
  return `?${queryString}`;
};
